import { Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';

@Component({
    standalone: false,
    selector: 'particle-survey-execution-settings',
  templateUrl: './survey-execution-settings.component.html',
  styleUrls: ['./survey-execution-settings.component.scss']
})
export class SurveyExecutionSettingsComponent implements OnInit, IDialogView {
  data: DialogModel;
  title: string;
  description: string;
  isCollaborative: boolean;
  canAddNewRecord: boolean;
  survey: any;

  constructor() {
    this.isCollaborative = false;
    this.canAddNewRecord = false;
  }

  ngOnInit() {
    if(this.data && this.data.input)
    {
      this.survey = this.data.input.survey;
      if(this.survey) {
        const date = new Date();
        this.title = `${this.survey.title} - ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`;
      }
    }
  }

  onOkClicked(): boolean {
    console.log(this.title);
    console.log(this.description);
    console.log(this.isCollaborative);
    console.log(this.canAddNewRecord);
    if(this.data && this.data.input)
    {
      this.data.input.executionSettings = {
        'title': this.title,
        'description': this.description,
        'isCollaborative': this.isCollaborative,
        'canAddNewRecord': this.canAddNewRecord
      };
    }
    return true;
  }

}
